import { useMemo } from 'react';
import { useField } from 'react-final-form';

import { TBlock } from '@wp-block-builder/package';

import blocksToFlatDocument from './helpers/blocksToFlatDocument';

export default function useFlatDocumentTree() {
  const blocks = useField<TBlock[]>('configuration.blocks').input.value;
  return useMemo(() => blocksToFlatDocument(blocks), [blocks]);
}
